export default __webpack_public_path__ + "static/media/yeshitla.2eba099d.jpg";